module.exports = __webpack_public_path__ + "img/stplus.f071d714.png";